import { createdATFilter } from 'modules/common/constants/';

export const establishmentFilters = [createdATFilter];
